<script>
  import { cart, paymentServices } from './storage.js';  
</script>


<div class="summary">
  {#if $cart}
    {#if $cart.all_digital}
      <div class="total">
        <div class="total__label">RAZEM:</div>
        <div class="total__value">{$cart.total_price_with_currency}</div>
      </div>
    {:else}
      <div class="subtotal">
        <div class="subtotal__label">Zamówienie:</div>
        <div class="subtotal__value">{$cart.products_price_with_currency}</div>
      </div>

      <div class="subtotal">
        <div class="subtotal__label">Dostawa:</div>
        <div class="subtotal__value">
          {#if $cart.delivery_method_id}
            {$cart.delivery_price_with_currency}
          {:else}
            -
          {/if}
        </div>
      </div>

      <div class="total">
        <div class="total__label">RAZEM:</div>
        <div class="total__value">{$cart.total_price_with_currency}</div>
      </div>

      <div class="total__delivery">
        {#if !$cart.delivery_method_id}
          + dostawa
        {:else if $cart.payment_on_delivery}
          płatność przy odbiorze
        {:else if $paymentServices}
          { $paymentServices.map(item => item.name).join(', ') }
        {/if}
      </div>
    {/if}
  {/if}
</div>


<style>
  .summary {
    border: 1px solid #e0e0e0;
    margin-bottom: 15px;
    padding: 20px 25px;
  }

  .total {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
  }

  .total__label {
    font-weight: bolder;
  }

  .total__value {
    font-weight: bold;
    font-size: 1.5em;
  }

  .total__delivery {
    width: 100%;
    text-align: right;
    font-size: 0.8em;
    line-height: 1.25;
  }

  .subtotal {
    display: flex;
    justify-content: space-between;
  }

  .subtotal__value {
    font-weight: bolder;
  }

  @media (max-width: 767px) {
    .summary {
      margin-bottom: 10px;
      padding: 10px;
    }
  }
</style>
